import keyMirror from 'keymirror';

const FORM_TYPES = keyMirror({ new: null, edit: null });

export default FORM_TYPES;
